import { SvgProps } from './interface/SvgProps';

const SvgSoiree = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={40}
        height={40}
        fill="none"
        viewBox="0 0 65 65"
        {...props}
    >
      <path
        fill="#E7E4D9"
        d="M3.333 20A16.667 16.667 0 0 0 20 36.667v-8.334A8.333 8.333 0 0 1 11.667 20H3.333ZM20 36.667A16.667 16.667 0 0 0 36.667 20h-8.334A8.334 8.334 0 0 1 20 28.333v8.334ZM36.666 20A16.668 16.668 0 0 0 20 3.333v8.334A8.333 8.333 0 0 1 28.333 20h8.333Z"
      />
      <path fill="#0B7D75" d="M20 3.333A16.667 16.667 0 0 0 3.333 20h8.333A8.333 8.333 0 0 1 20 11.667V3.333Z" />
    </svg>
);
  
export default SvgSoiree;
